module.exports = __webpack_public_path__ + "img/yorum-yok.0caa5768.png";